import type { AgentCapabilityPreset } from '../../types/generated/AgentCapabilityPreset'

/**
 * Capability presets (redesign §6): named capability bundles that
 * compile to raw `type:action:scope` lines. Every line is drawn from the
 * server's user-grantable catalog (`ALLOWED_USER_CAPABILITIES`), so
 * presets always validate server-side.
 */
const PRESET_LINES: Record<
  Exclude<AgentCapabilityPreset, 'custom'>,
  string[]
> = {
  readonly: ['llm:call:*'],
  collab: ['tool:use:*', 'llm:call:*'],
  builder: ['tool:use:*', 'llm:call:*', 'spawn:task', 'net:egress'],
}

/** Lines a preset compiles to (a stable copy, safe to write into state). */
export function compilePreset(
  preset: Exclude<AgentCapabilityPreset, 'custom'>,
): string[] {
  return [...PRESET_LINES[preset]]
}

/** The preset whose compiled lines exactly match `lines` — or `custom`
 * when nothing matches (hand-edited). Ordering-insensitive. */
export function matchPreset(lines: string[]): AgentCapabilityPreset {
  const sorted = [...lines].sort().join('\n')
  for (const key of Object.keys(PRESET_LINES) as Exclude<
    AgentCapabilityPreset,
    'custom'
  >[]) {
    if ([...PRESET_LINES[key]].sort().join('\n') === sorted) return key
  }
  return 'custom'
}
